/*
 * Copyright (c) ${year}. Sayari LLC
 */

export const environment = {
    production: false,
    apiUrl: 'https://qaapi.getspeckles.com',
    webUiUrl: 'https://qaweb.getspeckles.com'
};